import PocketBase from "pocketbase";
import { DEFAULT_UUD_SERVER_URL } from "../config";
import { normalizeUudServerUrl } from "../normalizeUudServerUrl";

/**
 * In development, use the current page origin when PB is unset or the default public host,
 * so /api/* is proxied (see src/setupProxy.js). If `REACT_APP_PB_URL` points elsewhere
 * (e.g. local PocketBase), use that URL.
 *
 * In production, `REACT_APP_PB_URL` wins if set. Otherwise, when `REACT_APP_PB_SAME_ORIGIN`
 * is true, use the page origin (Docker/nginx must proxy /api to PocketBase — see docker/nginx.conf).
 * Else default to DEFAULT_UUD_SERVER_URL (direct cross-origin; requires PB allowed origins).
 */
function isDefaultPublicPbUrl(url) {
  const s = String(url || "").trim().replace(/\/$/, "");
  return (
    s === "" ||
    s === DEFAULT_UUD_SERVER_URL ||
    s.startsWith("https://pb02.uud.io") ||
    s.startsWith("https://pb1.uud.io")
  );
}

function pbSameOriginFromEnv() {
  return (
    process.env.REACT_APP_PB_SAME_ORIGIN === "true" ||
    process.env.REACT_APP_PB_SAME_ORIGIN === "1"
  );
}

export function getPocketBaseUrl() {
  const fromEnv = normalizeUudServerUrl(
    String(process.env.REACT_APP_PB_URL || "")
      .trim()
      .replace(/\/$/, "")
  );
  if (process.env.NODE_ENV === "development") {
    if (fromEnv && !isDefaultPublicPbUrl(fromEnv)) {
      return fromEnv;
    }
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin.replace(/\/$/, "");
    }
    return DEFAULT_UUD_SERVER_URL;
  }
  if (fromEnv) return fromEnv;
  if (pbSameOriginFromEnv()) {
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin.replace(/\/$/, "");
    }
  }
  return DEFAULT_UUD_SERVER_URL;
}

const pb = new PocketBase(getPocketBaseUrl());

// The SDK cancels "duplicate" pending requests using only HTTP method + path (not query/body).
// Concurrent list calls to the same collection (e.g. getFullList for "my favorites" and
// getFirstListItem during toggleFavorite) would otherwise cancel each other with ClientResponseError 0.
pb.autoCancellation(false);

export default pb;
